import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

/* 🔓 Auth */
import Login from "./Login";
import PrivateRoute from "./PrivateRoute";

/* 🧱 Layout */
import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";

/* 📄 Pages */
import Dashboard from "./Dashboard/Dashboard";
import CreateUser from "./Users/CreateUser";
import UserList from "./Users/UserList";
import Members from "./Members/Members";
import Donations from "./Donations/Donations";
import Events from "./Events/Events";
import Gallery from "./Gallery/Gallery";
import Notices from "./Notices/Notices";
import Enquiry from "./Enquiry/Enquiry";
import Settings from "./Settings/Settings";

/* 🧩 Admin Layout */
function AdminLayout({ children }) {
  return (
    <>
      <Sidebar />
      <div className="main-wrapper">
        <Navbar />
        <div className="main-content">{children}</div>
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>

        {/* 🔓 Login Route */}
        <Route path="/login" element={<Login />} />

        {/* 🔐 Protected Admin Routes */}
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <AdminLayout>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/create-user" element={<CreateUser />} />
                  <Route path="/users" element={<UserList />} />
                  <Route path="/members" element={<Members />} />
                  <Route path="/donations" element={<Donations />} />
                  <Route path="/events" element={<Events />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/notices" element={<Notices />} />
                  <Route path="/enquiry" element={<Enquiry />} />
                  <Route path="/settings" element={<Settings />} />

                  {/* ❌ Fallback */}
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
              </AdminLayout>
            </PrivateRoute>
          }
        />

      </Routes>
    </Router>
  );
}

export default App;